const $$splitComponentImporter = () => import('/app/src/routes/dashboard/therapist/onboarding.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/therapist/onboarding")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});